// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"fbadeab6","956":"2f7f909e"}[chunkId] + ".chunk.js";
};